import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useUserPrefs } from '../Components/context/UserPrefs';
import { Modal } from '../Components/Modal/Modal';
import senerfiBlanco from '../assets/images/senerfiblanco.png';
import gruasenerfi from '../assets/images/gruasenerfi.png';
import BrandCopyright from '../Components/Common/BrandCopyright';
import { isNativeRuntime } from '../utils/runtimePlatform';
const ControlOperativoPanelLazy = React.lazy(() => import('./modules/ControlOperativoPanel'));

export default function ControlOperativo({ mobileMode = false }) {
  const { location } = useParams();
  const navigate = useNavigate();
  const { logout } = useUserPrefs();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleBrandClick = () => {
    window.location.reload();
  };

  const handleLogout = () => {
    try { logout(); } catch (_) {}
    try { if (typeof window !== 'undefined') { sessionStorage.setItem('senerfi_show_logout', '1'); } } catch (_) {}
    try { if (typeof window !== 'undefined') { localStorage.removeItem('senerfi_user_prefs'); } } catch (_) {}
    try {
      if (typeof window !== 'undefined') {
        const isNative = isNativeRuntime();
        if (isNative) {
          const base = window.location.href.split('#')[0];
          const target = base + '#/';
          try { window.location.href = target; } catch (_) {}
          try { window.location.assign(target); } catch (_) {}
          try { window.location.replace(target); } catch (_) {}
          try { window.location.hash = '/'; } catch (_) {}
          try { navigate('/', { replace: true }); } catch (_) {}
        } else {
          navigate('/', { replace: true });
        }
        setTimeout(() => { try { window.location.reload(); } catch (_) {} }, 150);
      }
    } catch (_) {}
  };

  return (
    <div className="min-h-screen bg-gray-50 relative">
      {mobileMode && null}
      {/* Header tipo inicio de página con logo */}
      <div className="w-full shadow-md" style={{ backgroundColor: '#F07E2D' }}>
        {mobileMode ? (
          <div className="max-w-6xl mx-auto grid grid-cols-3 items-center h-18 px-4">
            <div />
            <div className="flex justify-center items-center">
              <img src={gruasenerfi} alt="Senerfi" className="w-auto cursor-pointer" style={{ height: '3.825rem', maxWidth: '68vw', transform: 'scaleX(1.10)', transformOrigin: 'center' }} onClick={handleBrandClick} />
            </div>
            <div className="flex justify-end">
              <button
                type="button"
                onClick={handleLogout}
                className="inline-flex items-center justify-center w-10 h-10 rounded-full shadow-md"
                style={{ color: '#FFFFFF', backgroundColor: 'rgba(255,255,255,0.25)', border: '1px solid rgba(255,255,255,0.7)' }}
                aria-label="Cerrar sesión"
              >
                <LogOut size={28} strokeWidth={2.5} />
              </button>
            </div>
          </div>
        ) : (
          <div className="max-w-6xl mx-auto flex items-center h-14 px-4">
            <img src={senerfiBlanco} alt="Senerfi" className="h-8 w-auto cursor-pointer" onClick={handleBrandClick} />
          </div>
        )}
      </div>

      {confirmOpen && (
        <Modal isOpen={confirmOpen} onClose={() => setConfirmOpen(false)} title="Cerrar sesión" size="max-w-sm">
          <div className="space-y-4">
            <p className="text-sm text-gray-700">¿Deseas cerrar sesión y volver al inicio?</p>
            <p className="text-xs text-gray-600">Se perderá cualquier dato no guardado.</p>
            <div className="flex items-center justify-end gap-2">
              <button type="button" className="px-3 py-1 rounded border" onClick={() => setConfirmOpen(false)}>Cancelar</button>
              <button type="button" className="px-3 py-1 rounded bg-orange-600 hover:bg-orange-700 text-white shadow-md" onClick={handleLogout}>Cerrar sesión ahora</button>
            </div>
          </div>
        </Modal>
      )}

      {/* Contenido principal */}
      <div className={mobileMode ? "p-0 relative z-10" : "p-6 flex items-center justify-center relative z-10"}>
        <div className={mobileMode ? "bg-white min-h-screen" : "bg-white rounded-2xl shadow-2xl border border-gray-200 p-8 max-w-xl w-full"}>
          <React.Suspense fallback={<div className="p-6 text-center text-sm text-gray-600">Cargando Control Operativo…</div>}>
            <ControlOperativoPanelLazy location={location} showLocation={!mobileMode} mobileMode={mobileMode} />
          </React.Suspense>
        </div>
      </div>

      {/* Pie de página reutilizable */}
      {!mobileMode && (
        <BrandCopyright />
      )}
    </div>
  );
}
